<template>
    <crud-create
        :open="open"
        :loading="loading"
        :title="title"
        :errorMessage="errorMessage"
        @create="create"
        @close="$emit('close')"
    >
        <recargo-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-create>
</template>

<script>
import RecargoProvider from "../../../providers/RecargoProvider";
import UserConfigurationProvider from "../../../../user-configuration/providers/UserConfigurationProvider";
import { CrudCreate } from "@dracul/common-frontend";
import ClientError from "@/errors/ClientError";
import RecargoForm from "../RecargoForm";

export default {
    name: "RecargoCreate",

    components: { RecargoForm, CrudCreate },

    props: {
        open: { type: Boolean, default: true },
    },

    data() {
        return {
            title: "recargo.creating",
            errorMessage: "",
            inputErrors: {},
            loading: false,
            form: {
                nombre: null,
                recargo: null,
                deposito: null,
            },
        };
    },

    watch: {
        open(val) {
            if (val) this.setDepositoFromConfig();
        },
    },

    mounted() {
        this.setDepositoFromConfig();
    },

    methods: {
        async setDepositoFromConfig() {
            let depositoId = UserConfigurationProvider.getDepositoIdFromCache();
            if (!depositoId) {
                const res = await UserConfigurationProvider.getUserConfiguration(true);
                if (res && res.data && res.data.userConfigurationGet && res.data.userConfigurationGet.depositoIdSeleccionado) {
                    depositoId = res.data.userConfigurationGet.depositoIdSeleccionado;
                }
            }
            if (depositoId) this.form.deposito = depositoId;
        },
        create() {
            if (this.$refs.form.validate()) {
                this.loading = true;
                RecargoProvider.createRecargo(this.form)
                    .then((r) => {
                        if (r) {
                            this.$emit("itemCreated", r.data.recargoCreate);
                            this.$emit("close");
                        }
                    })
                    .catch((error) => {
                        let clientError = new ClientError(error);
                        this.inputErrors = clientError.inputErrors;
                        this.errorMessage = clientError.i18nMessage;
                    })
                    .finally(() => (this.loading = false));
            }
        },
    },
};
</script>

<style scoped></style>
